import { PrismicNextImage, PrismicNextLink } from '@prismicio/next';
import { Content, GroupField } from '@prismicio/client';
import { Simplify } from '../../../../../../prismicio-types';
import styles from './ImageContent.module.scss';

interface Props {
  data: GroupField<
    Simplify<Content.PartnerPagesListSliceDefaultPrimarySlidesItem>
  >;
  activeItem: number;
}

const ImageContent = ({ activeItem, data }: Props) => {
  return (
    <div className={styles.wrapper}>
      {data.map((el, index) => (
        <PrismicNextLink
          key={index}
          field={data[activeItem].button_link}
          className={`${styles.listItem} ${activeItem === index ? styles.activeItem : ''}`}
        >
          <PrismicNextImage className={styles.img} field={el.img} />
          <PrismicNextImage className={styles.mobImg} field={el.mobimg} />
        </PrismicNextLink>
      ))}
    </div>
  );
};

export default ImageContent;
